import React from 'react'
import moment from 'moment'
import { number, object, setLocale, string } from 'yup'
import { FormikProps, FormikValues } from 'formik'
import { Col, Form, Row } from 'antd'

import { DatePickerRange, SelectParticipant } from 'src/components/Formik'
import SelectOrganizationCurrentManager from 'src/components/Formik/select-organization-current-manager'

function getInitialValues() {
  const ended_on = moment.utc().endOf('month').unix()
  const started_on = moment.utc().startOf('month').unix()

  return {
    ended_on,
    organization_id: '',
    participant: '',
    started_on
  }
}

function getRenderForm() {
  return (formikProps: FormikProps<FormikValues>) => (
    <Form onSubmit={formikProps.handleSubmit}>
      <Row>
        <Col span={24}>
          <SelectOrganizationCurrentManager
            formikProps={formikProps}
            required
          />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <DatePickerRange
            formikProps={formikProps}
            label="web.reports.parameter.period.title"
            name={['started_on', 'ended_on']}
            placeholder={[
              'web.reports.parameter.period.placeholder-start',
              'web.reports.parameter.period.placeholder-end'
            ]}
            required={false}
            showTime={false}
          />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <SelectParticipant
            formikProps={formikProps}
            name="participant"
            required={false}
          />
        </Col>
      </Row>
    </Form>
  )
}

function getValidationSchema() {
  setLocale({
    mixed: {
      notType: 'common.required',
      required: 'common.required'
    }
  })

  return object().shape({
    ended_on: number().required().typeError(),
    organization_id: string().required(),
    participant: number().notRequired().typeError(),
    started_on: number().required().typeError()
  })
}

export { getRenderForm, getValidationSchema, getInitialValues }
